import {
  ArrayParam,
  createRoute,
  NumberParam,
  RequiredNumberParam,
  BooleanParam,
  StringParam,
  withDefault,
} from 'react-router-url-params';

export const Links = {
  Unauthorized: {
    Login: createRoute('/login'),
  },
  Authorized: {
    Dashboard: createRoute('/'),
    Templates: createRoute('/templates'),
    TemplatesMerging: createRoute('/templates-merging'),
    Projects: createRoute('/projects'),
    ProjectDetails: createRoute(
      '/projects/:projectId',
      { projectId: RequiredNumberParam },
      {
        releaseId: NumberParam,
        statusFilters: withDefault(ArrayParam, []),
        onlyNotUpdatedVersion: BooleanParam,
      },
    ),
    /**
     * The `create-release` path segment and the `releaseId` params below are kept
     * for link backwards compatibility, since the backend builds `?releaseId=` links in signing emails
     */
    CreateRevision: createRoute('/projects/:projectId/create-release', {
      projectId: RequiredNumberParam,
    }),

    CreateDocument: createRoute(
      '/projects/:projectId/releases/:releaseId/create-document',
      {
        projectId: RequiredNumberParam,
        releaseId: RequiredNumberParam,
      },
      {
        folderId: StringParam,
      },
    ),

    OpenDocument: createRoute(
      '/projects/:projectId/releases/:releaseId/documents/:documentId',
      {
        projectId: RequiredNumberParam,
        releaseId: RequiredNumberParam,
        documentId: NumberParam,
      },
    ),

    OpenTemplate: createRoute('/templates/:templateId', {
      templateId: RequiredNumberParam,
    }),

    UiKit: createRoute('/uikit'),
  },
};
